// extracted by mini-css-extract-plugin
export default {"wrapper":"breadcrumb_wrapper__U-xFK","link":"breadcrumb_link__ihqDh"};